export default __webpack_public_path__ + "static/media/ER16.64633168.png";